import { NmsWizardStepModel } from "@nms-angular-toolkit/nms-wizard";
import { ChannelData } from "../2-transponders/transponders-step.model";
import {
    DwdmCircuitAmplifierModeTypeData,
    DwdmCircuitAmplifierProfileData
} from "../5-amplifiers/amplifiers-step.model";
import { CircuitPortIdentifierData } from "../6-osc-management/osc-management-step.model";

/**
 * Representa o modelo do step General do DwdmCircuitWizard.
 */
export class GeneralStepModel extends NmsWizardStepModel {
    circuitId?: number;
    name: string;
    description: string;
    generatedName: boolean;

    constructor() {
        super();
        this.name = "";
        this.description = "";
        this.generatedName = true;
    }
}

/**
 * Modelo que representa os resumo dos dados dos ends
 */
export interface DwdmCircuitEndsData {
    aEndName: string;
    zEndName: string;
    aEndPorts: Array<DwdmCircuitPortBean>;
    zEndPorts: Array<DwdmCircuitPortBean>;
}

/**
 * Modelo que representa as informações de uma porta DWDM.
 */
export interface DwdmCircuitPortBean {
    portNo: string;
    portModel: string;
    portName: string;
}

/**
 * Modelo que representa as informações de um circuito DWDM.
 */
export interface DwdmCircuitData {
    circuitId?: number;
    circuitName: string;
    circuitDescription: string;
    autoGeneratedName: boolean;
    aEnd: DwdmCircuitEndData;
    zEnd: DwdmCircuitEndData;
    intermediatesResourcesIds: Array<number>;
    linksResourcesIds: Array<number>;
    oscs: Array<DwdmCircuitOscData>;
    amplifiers: Array<DwdmCircuitAmplifierData>;
}

/** Modelo que representa as informações de um end do circuito */
export interface DwdmCircuitEndData {
    muxEnabled: boolean;
    muxResourceId: number;
    endConfigurationsData: Array<DwdmCircuitEndConfigurationData>;
}

/** Modelo que representa as informações de um amplificador do circuito */
export interface DwdmCircuitAmplifierData {
    value: number;
    limit: number;
    losThreshold: number;
    losAction: boolean;
    amplifierPort: CircuitPortIdentifierData;
    circuitAmplifierProfileData: DwdmCircuitAmplifierProfileData;
    circuitAmplifierModeTypeData: DwdmCircuitAmplifierModeTypeData;
}

/** Modelo que representa as informações de configuração de um end do circuito */
export interface DwdmCircuitEndConfigurationData {
    endPort: CircuitPortIdentifierData;
    channel: ChannelData;
    multirate: string;
    txPower: number;
}

/** Modelo que representa uma porta de gerencia do circuito DWDM. */
export interface DwdmCircuitOscData {
    oscPort: CircuitPortIdentifierData;
    linkTx: number;
    linkRx: number;
}
